import React, { useState } from "react";
import T from "prop-types";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import { connect } from "react-redux";
import { updateROLineItem } from "MODULES/RepairOrders/actions";
import ShippingSection from "MODULES/RepairOrders/components/Detail/LineItems/FormSections/ShippingSection/ShippingSection";
import {
  getDisableReturnFields,
  getDisplayShipmentVal,
  getLocationsAndReturnToTypes,
  getOutrightVal,
  isDropshippedSales,
  isDropshipping
} from "MODULES/RepairOrders/components/Detail/LineItems/helpers";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import {
  ACTION_REQUESTED,
  APPROVAL_STATUS,
  AWAITING_TO_SHIP,
  INCOMING_AWB_NUMBER,
  RETURNED_DATE
} from "MODULES/RepairOrders/constants";
import { Button, Col } from "react-bootstrap";
import { Field } from "redux-form";
import _, { isEmpty } from "lodash";
import { dateFormFormat } from "LIB/formatters/date";
import { properCase } from "LIB/formatters/text";
import { onSuccess } from "LIB/submission";
import { Warning } from "MODULES/shared/components";
import {
  SEND_SALES_ORDER_ACKNOWLEDGEMENT,
  SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL
} from "MODULES/SalesOrders/constants";

const FORM_NAME = "updateReturnShipping";

function Form(props) {
  const {
    disabled,
    displayShipmentUpdateReminder,
    getFieldValue,
    getInitialFieldValue,
    handleSubmit,
    lineItem,
    setFieldValue
  } = props;

  const submit = onSuccess(handleSubmit, props.close, props);
  const [confirmDropship, setConfirmDropship] = useState(false);
  const hasGoneOutright = getOutrightVal(getFieldValue);
  const requestedAction = getFieldValue(ACTION_REQUESTED);

  const [hasLocations, returnToTypes] = getLocationsAndReturnToTypes(
    true,
    hasGoneOutright,
    lineItem
  );

  const approvalStatus = getFieldValue(APPROVAL_STATUS);
  const disableReturnFields = getDisableReturnFields(disabled, getFieldValue);
  const dropshipping = isDropshipping({
    getFieldValue,
    getInitialFieldValue,
    repairItem: lineItem
  });

  const showWarningStep = dropshipping && !confirmDropship;

  const dropShipText = isDropshippedSales(lineItem) ? "sale" : "managed repair";

  return (
    <AppForm {...props}>
      <AppForm.Body>
        {confirmDropship && (
          <Warning>
            <p>
              Once the Return AWB # is saved for a return repair item that is
              dropshipped for a pending {dropShipText}, this record will
              automatically ship in the system.
            </p>

            <p>Are you sure you want to continue?</p>
          </Warning>
        )}
        <div className={confirmDropship && "hidden"}>
          <ShippingSection
            formName={FORM_NAME}
            shippingTypes={returnToTypes}
            getField={getFieldValue}
            lineItem={lineItem}
            ship_to_fields_required={false}
            getInitialField={getInitialFieldValue}
            requestedAction={requestedAction}
            displayShipmentUpdateReminder={displayShipmentUpdateReminder}
            hasLocations={hasLocations}
          />
          <div className="row row-col-gutters-half" key="awb-date-section">
            {approvalStatus !== AWAITING_TO_SHIP && (
              <Col md={3}>
                <Field
                  name={INCOMING_AWB_NUMBER}
                  component={FormInput}
                  disabled={disableReturnFields}
                  label="Returning AWB #"
                  onChange={(_ev, val) => {
                    if (
                      !isEmpty(val) &&
                      isEmpty(getInitialFieldValue(INCOMING_AWB_NUMBER))
                    ) {
                      setFieldValue(RETURNED_DATE)(dateFormFormat(Date.now()));

                      if (dropshipping) {
                        setFieldValue(SEND_SALES_ORDER_ACKNOWLEDGEMENT)(true);
                      }
                    }
                  }}
                />
              </Col>
            )}
            <Col md={3}>
              <Field
                name={RETURNED_DATE}
                label={properCase(RETURNED_DATE)}
                component={FormInput}
                type="date"
                disabled={disableReturnFields}
              />
            </Col>
            {dropshipping &&
              isDropshippedSales(lineItem) && (
                <Col md={3}>
                  <CheckGroup
                    title={properCase(SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL)}
                  >
                    <Field
                      component={Check}
                      name={SEND_SALES_ORDER_ACKNOWLEDGEMENT}
                      label={SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL}
                    />
                  </CheckGroup>
                </Col>
              )}
          </div>
        </div>
      </AppForm.Body>

      <AppForm.Footer>
        <Button onClick={props.close}>Cancel</Button>
        <Button
          type="button"
          disabled={props.submitting}
          onClick={showWarningStep ? () => setConfirmDropship(true) : submit}
          bsStyle="primary"
        >
          {props.submitting && <i className="fa fa-cog fa-spin fa-fw fa-lg" />}
          {props.submitting ? "Saving" : "Save"}
        </Button>
      </AppForm.Footer>
    </AppForm>
  );
}

export default connect(
  state => ({
    displayShipmentUpdateReminder: getDisplayShipmentVal(FORM_NAME, state)
  }),
  (dispatch, ownProps) => ({
    onSubmit: data => dispatch(updateROLineItem(ownProps.lineItem.id, data))
  })
)(
  form({
    form: FORM_NAME
  })(withFieldAccessors(Form))
);

Form.propTypes = {
  approveROLineItem: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/ReturnRepairItem/Form.jsx